import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';
import { EVENT_EMITTERS, PATHS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { ModalService } from '../../../shared/directives/modal/modal.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import { CreativeAdSize, CreativePerformance } from '../creative-detail-v2/creative-detail.interface';

@Component({
	selector: 'app-display-creative',
	styleUrls: ['./display-creative.component.css'],
	templateUrl: './display-creative.component.html'
})
export class DisplayCreativeComponent implements OnInit, WidgetCore, OnDestroy {
	public key: string;
	public showLoad = true;
	public hasData: boolean;
	public placeholderimage: string;
	public isPreroll: boolean;
	public isDisplay: boolean;
	public isRadio: boolean;
	public isEmail: boolean;
	public isSocial: boolean;
	public isDOOH: boolean = false;
	public downloadCSVColumns: any;
	@Input() sectiontitle;
	@Input() defaultsort: string;
	@Input() downloadconfig: string;
	@Input() sectionclass: any;
	@Input() downloadcsvcolumns: any;
	@Input() datatableconfig;
	@Input() producttype: string;
	@ViewChild('tvNetworkLogo') el: ElementRef;

	public downloadConfiguration: DownloadConfig;
	public creatives: CreativePerformance[] = [];
	public displayCreative = {} as CreativePerformance;
	public videoCreativeData: any;
	public totalCreatives: number;
	public displayIndex: any;
	public count: any;
	public reloadSubscription;
	public widgetDataSubscription;
	public selectedCreative: CreativePerformance;
	public partnerName: string;
	public isTelevisionCreative: boolean;
	public downloadIcon: any = false;
	public itemsPerPage = 10;
	public topLinksData = [];
	public newTabXLSXRequired: boolean = false;
	public allowTelevisionCreative: boolean = false;
	public isGam: boolean = false;
	public isR1102: boolean = false;
	public isR103: boolean = false;
	public isR6: boolean = false;
	public isR9: boolean = false;
	public isR8: boolean = false;
	public isR3: boolean = false;
	public isR4: boolean = false;
	public isR7: boolean = false;
	public isR701: boolean = false;
	public isR702: boolean = false;
	public isR104: boolean = false;
	public isR101: boolean = false;
	public isR5: boolean = false;

	public tooltipR3Options = {
		animation: 'fade',
		arrow: true,
		duration: 750,
		dynamicTitle: true,
		position: 'top',
		scale: 'big'
	};

	constructor(
		protected analyticsService: AnalyticsService,
		protected modalService: ModalService,
		protected sanitizer: DomSanitizer,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			if (this.isPreroll || this.isRadio) {
				this.requestPrerollData();
			} else {
				this.requestData();
			}
		});
	}

	ngOnInit(): void {
		this.isR103 =
			this.analyticsDataModel.config.directoryName.toLowerCase() === 'default-r103' ||
			this.analyticsDataModel.config.directoryName.toLowerCase() === 'entravision-r103'
				? true
				: false;
		this.isR1102 = ['default-r11', 'default-r1101', 'default-r1102', 'quincy-r11', 'default-r6'].includes(
			this.analyticsDataModel.config.directoryName.toLowerCase()
		)
			? true
			: false;
		this.isR6 = this.analyticsDataModel.config.version.toLowerCase() == 'r6' ? true : false;
		this.isR4 = this.analyticsDataModel.config.version.toLowerCase() == 'r4' ? true : false;
		this.isR9 = this.analyticsDataModel.config.version.toLocaleLowerCase() == 'r9' ? true : false;
		this.isR8 = this.analyticsDataModel.config.version.toLocaleLowerCase() == 'r8' ? true : false;
		this.isR3 = ['default-r3', 'default-marketron-r3'].includes(
			this.analyticsDataModel.config.directoryName.toLowerCase()
		);
		this.isR7 = this.analyticsDataModel.config.directoryName.toLocaleLowerCase() == 'default-r7' ? true : false;
		this.isR701 = this.analyticsDataModel.config.directoryName.toLocaleLowerCase() == 'default-r701' ? true : false;
		this.isR702 = this.analyticsDataModel.config.directoryName.toLocaleLowerCase() == 'default-r702' ? true : false;
		this.isR104 = this.analyticsDataModel.config.directoryName.toLocaleLowerCase() == 'default-r104' ? true : false;
		this.isR101 = this.analyticsDataModel.config.directoryName.toLocaleLowerCase() == 'default-r101' ? true : false;
		this.isR5 = this.analyticsDataModel.config.directoryName.toLocaleLowerCase() == 'default-r5' ? true : false;
		this.partnerName = this.analyticsDataModel.partner.partnerName;
		this.allowTelevisionCreative =
			this.analyticsDataModel.config.directoryName.includes('r102') ||
			this.analyticsDataModel.config.directoryName.includes('r103')
				? true
				: false;
		this.isTelevisionCreative = this.sectiontitle.indexOf('Television Creative') !== -1;
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		this.isDisplay = this.analyticsDataModel.getCurrentPath() === PATHS.DISPLAY;
		this.isPreroll = this.analyticsDataModel.getCurrentPath() === PATHS.PREROLL;
		this.isRadio = this.analyticsDataModel.getCurrentPath() === PATHS.RADIO;
		this.isGam = this.analyticsDataModel.getCurrentPath() === PATHS.GAM;
		this.isSocial = this.analyticsDataModel.getCurrentPath() === PATHS.SOCIAL;
		this.isDisplay = this.analyticsDataModel.getCurrentPath() === PATHS.DISPLAY;
		this.isEmail =
			this.analyticsDataModel.getCurrentPath() === PATHS.Email
				? true
				: this.analyticsDataModel.getCurrentPath() === PATHS.OVERVIEW
				? this.sectiontitle.indexOf('email') !== -1
				: false;
		this.isDOOH = this.analyticsDataModel.getCurrentPath() === PATHS.DOOH;
		this.downloadCSVColumns = this.downloadcsvcolumns ? JSON.parse(decodeURI(this.downloadcsvcolumns)) : [];
		if (this.defaultsort === 'true') {
			this.defaultsort = JSON.parse(this.defaultsort);
		} else {
			this.defaultsort = null;
		}
		if (this.isPreroll || this.isRadio) {
			this.requestPrerollData();
		} else {
			this.requestData();
		}
		this.downloadIcon = this.analyticsDataModel.config.downloadIcon
			? this.analyticsDataModel.config.downloadIcon
			: this.downloadIcon;

		if (
			this.downloadConfiguration &&
			this.downloadConfiguration.permission &&
			this.downloadConfiguration?.permission['flags']
		) {
			this.newTabXLSXRequired = !this.downloadConfiguration.permission['flags']
				.map((permission) => {
					return this.analyticsDataModel
						.checkComponentForPermission({ permission: { flags: [permission] } })
						.toString();
				})
				.includes('false');
		}
	}

	checkFontSize(): void {
		let elems;
		setTimeout(() => {
			elems = document.querySelectorAll('#tvNetworkLogo');
			for (const elem of elems) {
				this.reduceFontSize(elem);
			}
		}, 0);
	}
	reduceFontSize(element: any): void {
		if (element.scrollWidth > element.clientWidth) {
			const fontSize = parseInt(element.style.fontSize, 10) - 1;
			if (fontSize > 1) {
				element.style.fontSize = fontSize + 'px';
				this.reduceFontSize(element);
			}
		}
	}

	ngOnDestroy(): void {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
		this.selectedCreative = undefined;
	}

	requestPrerollData(): void {
		this.hasData = true;
		this.showLoad = true;
		this.count = 1;
		this.analyticsService.processWidgetRequest(this.key).subscribe((response: any) => {
			this.showLoad = false;
			if (response.success) {
				this.hasData = true;
				this.processResponseData(response.data);
			} else {
				this.hasData = false;
				this.creatives = [];
				this.totalCreatives = 0;
				this.displayCreative = {} as CreativePerformance;
			}
		});
	}

	requestData(): void {
		this.hasData = true;
		this.showLoad = true;
		this.count = 1;
		this.widgetDataSubscription = this.analyticsService
			.processCustomServiceRequest(this.key)
			.subscribe((response: any) => {
				this.showLoad = false;
				if (response.success) {
					this.hasData = true;
					this.processResponseData(response.data);
				} else {
					this.hasData = false;
					this.creatives = [];
					this.totalCreatives = 0;
					this.displayCreative = {} as CreativePerformance;
				}
			});
	}

	processResponseData(responseData: any): void {
		if (responseData.length > 0) {
			responseData.map((data) => {
				if (!data.creative_name) {
					data['creative_name'] = data.name;
				}
			});
			this.creatives = this.mapResponseDataToInterface(responseData);
			if (!this.defaultsort) {
				this.displayIndex = this.creatives.length - 1;
			} else {
				this.displayIndex = 0;
			}
			this.totalCreatives = this.creatives.length;
			this.setSlide();
			this.setDisplayIndexContent(this.displayIndex);
		} else {
			this.hasData = false;
		}
	}

	setSlide(): void {
		this.nextArrow();
		this.prevArrow();
		this.checkFontSize();
	}

	setDisplayIndexContent(displayIndex: number): void {
		if (this.creatives.length > 0) {
			this.displayCreative = this.creatives[displayIndex];
			this.topLinksData = this.displayCreative.topLinks;
		} else {
			this.displayCreative = {} as CreativePerformance;
			this.topLinksData = [];
		}
	}

	nextArrow(): void {
		if (this.creatives.length > 1) {
			if (this.displayIndex === 0) {
				this.displayIndex = this.creatives.length - 1;
				this.setDisplayIndexContent(this.displayIndex);
			} else {
				this.displayIndex = this.displayIndex - 1;
				this.setDisplayIndexContent(this.displayIndex);
			}
		}
		if (this.count === 1) {
			this.count = this.creatives.length;
		} else {
			this.count = this.count - 1;
		}
		EmitterService.get('PLAY_SELECTED_VIDEO').emit(this.displayCreative);
		this.checkFontSize();
	}

	prevArrow(): void {
		if (this.creatives.length > 1) {
			if (this.creatives.length - 1 === this.displayIndex) {
				this.displayIndex = 0;
				this.setDisplayIndexContent(this.displayIndex);
			} else {
				this.displayIndex = this.displayIndex + 1;
				this.setDisplayIndexContent(this.displayIndex);
			}
		}
		if (this.creatives.length === this.count) {
			this.count = 1;
		} else {
			this.count = this.count + 1;
		}
		EmitterService.get('PLAY_SELECTED_VIDEO').emit(this.displayCreative);
		this.checkFontSize();
	}

	openModal(id: string, creative: CreativePerformance): void {
		if (!this.selectedCreative) {
			this.selectedCreative = creative;
		}
		this.modalService.open(id);
	}

	closeModal(id: string): void {
		this.modalService.close(id);
		this.selectedCreative = undefined;
	}

	mapResponseDataToInterface(responseData: any): CreativePerformance[] {
		const creativePerformances: CreativePerformance[] = [];
		for (const response of responseData) {
			const creativeObj: CreativePerformance = {} as CreativePerformance;
			const networkInfoArray = [];
			creativeObj.creativeName = response.creative_name || response.name;
			creativeObj.versionId = parseFloat(response.cup_version_id);
			creativeObj.clicks = parseFloat(response.clicks);
			creativeObj.clickRate = parseFloat(response.click_rate).toFixed(2);
			creativeObj.opens = parseFloat(response.opens);
			creativeObj.openRate = parseFloat(response.open_rate).toFixed(2);
			creativeObj.audience = parseFloat(response.audience);
			creativeObj.date = response.date;
			creativeObj.fromLine = response.from_line;
			creativeObj.adInteractions = Number.isNaN(parseFloat(response.ad_interactions))
				? null
				: parseFloat(Number(response.ad_interactions).toFixed(2));
			creativeObj.adInteractionRate = Number.isNaN(parseFloat(response.interaction_rate))
				? null
				: parseFloat(response.interaction_rate).toFixed(2);
			creativeObj.impressions = parseFloat(response.impressions);
			creativeObj.isVideoCreative = !UtilityService.isUndefined(response.video_url || response.mp4);
			creativeObj.isTelevision = this.sectiontitle.indexOf('Television Creative') !== -1;
			creativeObj.isEmail = this.sectiontitle.indexOf('email') !== -1;
			creativeObj.isSocial = this.sectiontitle.indexOf('social') !== -1;
			if (creativeObj.isSocial) {
				creativeObj.engagements = UtilityService.isUndefinedOrNull(response.engagements)
					? 0
					: parseFloat(response.engagements);
				creativeObj.likes = UtilityService.isUndefinedOrNull(response.likes) ? 0 : parseFloat(response.likes);
				creativeObj.comments = UtilityService.isUndefinedOrNull(response.comments) ? 0 : parseFloat(response.comments);
				creativeObj.reactions = UtilityService.isUndefinedOrNull(response.reactions)
					? 0
					: parseFloat(response.reactions);
				creativeObj.shares = UtilityService.isUndefinedOrNull(response.shares) ? 0 : parseFloat(response.shares);
				creativeObj.saves = UtilityService.isUndefinedOrNull(response.saves) ? 0 : parseFloat(response.saves);
			}
			if (creativeObj.isSocial) {
				creativeObj.creativeThumbnail =
					response.creative_thumbnail_image && response.creative_thumbnail_image !== ''
						? decodeURIComponent(
								response.creative_thumbnail_image.slice(
									response.creative_thumbnail_image.includes('http')
										? response.creative_thumbnail_image.lastIndexOf('http')
										: 0
								)
						  )
						: null;
				UtilityService.checkImageURLExpired(creativeObj.creativeThumbnail).then((exists) => {
					if (!exists) {
						creativeObj.creativeThumbnail = null;
					}
				});
			} else {
				creativeObj.creativeThumbnail =
					UtilityService.isUndefinedOrNull(response.creative_thumbnail_image) ||
					response.creative_thumbnail_image === ''
						? this.placeholderimage
						: UtilityService.checkEncodeURI(response.creative_thumbnail_image)
						? response.creative_thumbnail_image
						: encodeURI(response.creative_thumbnail_image);
			}
			if (response.thumbnail && !creativeObj.isSocial) {
				creativeObj.creativeThumbnail = UtilityService.isUndefinedOrNull(response.thumbnail)
					? this.placeholderimage
					: UtilityService.checkEncodeURI(response.thumbnail)
					? response.thumbnail
					: encodeURI(response.thumbnail);
			}
			creativeObj.iframeUrl = UtilityService.isUndefinedOrNull(response.iframe_url) ? null : response.iframe_url;
			if (creativeObj.isVideoCreative) {
				creativeObj.creativeVideo = response.video_url || response.mp4;
				creativeObj.completionRate = UtilityService.isUndefinedOrNull(response.completion_rate)
					? 0
					: parseFloat(response.completion_rate).toFixed(2);
				creativeObj.completions = UtilityService.isUndefinedOrNull(response.completion_value)
					? 0
					: parseInt(response.completion_value, 10);
			}
			creativeObj.isIframeExpired = response.is_iframe_expired;
			if (creativeObj.iframeUrl) {
				creativeObj.isVideoCreative = creativeObj.isIframeExpired === 1 ? false : true;
			}
			if (response.network_for_creatives) {
				const networkInfo = response.network_for_creatives;
				for (const item of networkInfo) {
					if (item.network_url !== '') {
						networkInfoArray.push({
							logo: item.network_url ? item.network_url : '',
							name: item.friendly_name ? item.friendly_name : ''
						});
					} else if (item.network_url === '') {
						networkInfoArray.push({
							logo: '',
							marphedlogo: item.friendly_name ? item.friendly_name.split(/\s+/).slice(0, 4).join(' ') : '',
							name: item.friendly_name ? item.friendly_name : ''
						});
					}
				}
			}
			creativeObj.exposures = UtilityService.isUndefinedOrNull(response.exposures) ? 0 : parseFloat(response.exposures);
			creativeObj.zones = UtilityService.isUndefinedOrNull(response.zones) ? 0 : parseFloat(response.zones);
			creativeObj.networkData = networkInfoArray;
			creativeObj.snapshotImage = response.snapshot_path;
			creativeObj.hasSnapshotImage = !UtilityService.isUndefinedOrNull(response.snapshot_path);
			creativeObj.adSizes = !creativeObj.isVideoCreative
				? this.mapResponseToAdSizes(response.creatives_by_ads ? response.creatives_by_ads : [])
				: ({} as { string: CreativeAdSize });
			creativeObj.hasAdSizes = !creativeObj.isVideoCreative ? !!response.creatives_by_ads : false;
			creativeObj.isIAB = UtilityService.isUndefinedOrNull(response.isIAB)
				? false
				: Number(response.isIAB)
				? true
				: false;
			creativeObj.isNative = UtilityService.isUndefinedOrNull(response.isNative)
				? false
				: Number(response.isNative)
				? true
				: false;
			creativeObj.native = response.native;
			creativeObj.percentValue100 = response['100_percent_value'];
			creativeObj.percentRate100 = response['100_percent_rate'];
			creativeObj.percentValue75 = response['75_percent_value'];
			creativeObj.percentRate75 = response['75_percent_rate'];
			creativeObj.percentValue50 = response['50_percent_value'];
			creativeObj.percentRate50 = response['50_percent_rate'];
			creativeObj.percentValue25 = response['25_percent_value'];
			creativeObj.percentRate25 = response['25_percent_rate'];
			creativeObj.mediaFiles = response.media_files;
			if (this.isEmail) {
				creativeObj.topLinks = response.url_by_adgroup;
				creativeObj.topLinks.sort((a, b) => b.url_clicks - a.url_clicks);
			}
			creativePerformances.push(creativeObj);
		}
		if (this.isEmail) {
			return creativePerformances.sort((a, b) => {
				const date1 = new Date(a.date);
				const date2 = new Date(b.date);
				return date1.getTime() - date2.getTime() != 0
					? date1.getTime() - date2.getTime()
					: b.clicks - a.clicks != 0
					? b.clicks - a.clicks
					: b.opens - a.opens;
			});
		} else return creativePerformances;
	}

	downloadDataInCSV(event: any): void {
		event.preventDefault();
		this.analyticsService.downloadCSV(
			this.downloadConfiguration.csvQueryKey,
			this.downloadConfiguration.fileName,
			this.downloadCSVColumns,
			null,
			this.newTabXLSXRequired ? this.downloadConfiguration.newTabCsvQueryKey : '',
			this.newTabXLSXRequired ? this.downloadConfiguration.newTabCsvFileName : ''
		);
	}

	getCreativeSize(thumbnail: string): string {
		if (
			thumbnail?.includes('728x90') ||
			thumbnail?.includes('468x60') ||
			thumbnail?.includes('320x50') ||
			thumbnail?.includes('300x50')
		) {
			return '100% 30%';
		} else if (thumbnail?.includes('300x600')) {
			return '75% 100%';
		} else if (thumbnail?.includes('160x600')) {
			return '40% 100%';
		} else {
			return '100% 100%';
		}
	}

	getPreviewScreenshot(imageURL: string): void {
		const win = window.open(imageURL, '_blank');
		win.focus();
	}

	protected mapResponseToAdSizes(responseData: any): any {
		const creativeAdSizeObj: { string: CreativeAdSize } = {} as { string: CreativeAdSize };
		for (const response of responseData) {
			const adSizeObj: CreativeAdSize = {} as CreativeAdSize;
			adSizeObj.adSize = response.ad_size;
			adSizeObj.creativeThumbnail = UtilityService.checkEncodeURI(response.creative_image)
				? response.creative_image
				: encodeURI(response.creative_image);
			adSizeObj.cupVersionId = response.cup_version_id;
			creativeAdSizeObj[adSizeObj.adSize] = adSizeObj;
		}
		return creativeAdSizeObj;
	}
}
